export default __webpack_public_path__ + "static/media/EcomReact.cb81ccd1.PNG";